export enum CandleTypes {
    OI = 'OI',
    OHLC = 'OHLC',
    OTHER = 'OTHER'
}

export enum ChartUpdateType {
    INITIAL = 'INITIAL',
    PREVIOUS = 'PREVIOUS',
    LIVE = 'LIVE'
}

export enum DateSource {
    CALENDER,
    RANGE,
    NONE
}